import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const Footer: React.FC = () => {
  const { data, language } = useLanguage();
  const settings = data.site_settings;

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center mb-4">
              <img 
                src={settings.logo} 
                alt={settings.site_name}
                className="h-8 w-auto mr-3"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                }}
              />
              <h3 className="text-xl font-bold">{settings.site_name}</h3>
            </div>
            <p className="text-gray-300 mb-4">{settings.site_description}</p>
            <div className="text-sm text-gray-400">
              <p>{language === 'ar' ? 'تأسست عام' : 'Established'} {settings.company_info.established}</p>
              <p>{settings.company_info.location}</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">
              {language === 'ar' ? 'روابط سريعة' : 'Quick Links'}
            </h4>
            <ul className="space-y-2">
              {data.slideshow.active && (
                <li>
                  <a href="#hero" className="text-gray-300 hover:text-white transition-colors">
                    {data.slideshow.title}
                  </a>
                </li>
              )}
              {data.ourservice.active && (
                <li>
                  <a href="#services" className="text-gray-300 hover:text-white transition-colors">
                    {data.ourservice.title}
                  </a>
                </li>
              )}
              {data.ourprojects.active && (
                <li>
                  <a href="#projects" className="text-gray-300 hover:text-white transition-colors">
                    {data.ourprojects.title}
                  </a>
                </li>
              )}
              {data.technews.active && (
                <li>
                  <a href="#technews" className="text-gray-300 hover:text-white transition-colors">
                    {data.technews.title}
                  </a>
                </li>
              )}
              {data.contactus.active && (
                <li>
                  <a href="#contact" className="text-gray-300 hover:text-white transition-colors">
                    {data.contactus.title}
                  </a>
                </li>
              )}
            </ul>
          </div>

          {/* Social Media */}
          <div>
            <h4 className="text-lg font-semibold mb-4">
              {language === 'ar' ? 'تابعنا' : 'Follow Us'}
            </h4>
            <div className="flex space-x-4">
              {settings.social_media.twitter !== '#' && (
                <a 
                  href={settings.social_media.twitter}
                  className="text-gray-300 hover:text-white transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="sr-only">Twitter</span>
                  🐦
                </a>
              )}
              {settings.social_media.linkedin !== '#' && (
                <a 
                  href={settings.social_media.linkedin}
                  className="text-gray-300 hover:text-white transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="sr-only">LinkedIn</span>
                  💼
                </a>
              )}
              {settings.social_media.github !== '#' && (
                <a 
                  href={settings.social_media.github}
                  className="text-gray-300 hover:text-white transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="sr-only">GitHub</span>
                  🐙
                </a>
              )}
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>
            © {new Date().getFullYear()} {settings.site_name}. 
            {language === 'ar' ? ' جميع الحقوق محفوظة.' : ' All rights reserved.'}
          </p>
        </div>
      </div>
    </footer>
  );
};